// COMPONENTS
import BalanceTooltip from "src/components/wallets/header/BalanceTooltip";
import PresentIcon from "src/icons/PresentIcon";
import { PromotionalPlacard } from "../../styles/Trade.styles";

interface PromotionalFeeDisplayProps {
  message: string;
}

export const PromotionalFeeDisplay: React.FC<PromotionalFeeDisplayProps> = ({ message }) => {
  return (
    <BalanceTooltip id="promotional-placard-tooltip" message={message} contrast>
      <PromotionalPlacard>
        <PresentIcon width="12" height="12" color="#056645" />
        Promotional fee applied
      </PromotionalPlacard>
    </BalanceTooltip>
  );
};
